export interface ItemTaxCalculationResult {
  taxAmount: number;
  taxRate: number;
  taxDescription: string;
  taxConfig: any | null;
}

export const getItemPurchaseTaxInfo = (
  elementId: number | string | undefined,
  allItems: any[],
  taxesOptions: any[]
): any | null => {
  if (!elementId) return null;
  const found = allItems.find((i) => String(i.id) === String(elementId));
  const opts =
    found?.storage_element_module_options || found?.module_options || [];
  const taxOpt = opts.find(
    (o: any) =>
      (o.sub_type === 'PURCHASE_TAX' || o.category === 'PURCHASE_TAX') &&
      o.is_active !== false
  );
  if (!taxOpt) return null;
  const taxConfig = (taxesOptions || []).find(
    (t: any) => t.id === taxOpt.option_id
  );
  return taxConfig || null;
};

export const calculateInputItemTax = (
  item: any,
  logType: string,
  applyCatalogTaxes: boolean,
  taxConfig: any | null
): ItemTaxCalculationResult => {
  if (
    (logType !== 'SUPPLY_PURCHASE' && logType !== 'SERVICE_EXPENSE') ||
    !applyCatalogTaxes ||
    !taxConfig
  ) {
    return { taxAmount: 0, taxRate: 0, taxDescription: '', taxConfig: null };
  }
  const qty = Number(item?.quantity || 0);
  const price = Number(item?.unit_price || 0);
  const subtotal = qty * price;
  const rate =
    taxConfig.type === 'TAX_RATE' ? Number(taxConfig.numeric_value) || 0 : 0;
  const fixed =
    taxConfig.type === 'TAX_FIXED' ? Number(taxConfig.numeric_value) || 0 : 0;
  const taxAmount =
    Math.round((subtotal * (rate / 100) + fixed + Number.EPSILON) * 100) / 100;

  return {
    taxAmount,
    taxRate: rate,
    taxDescription: taxConfig.string_value || taxConfig.key || 'IVA',
    taxConfig,
  };
};
